var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2882 25.7001L7.33789 21.1413L7.36227 12.0671M15.2882 25.7001L23.241 30.2588M15.2882 25.7001V21.7498M7.36227 12.0671L7.38924 2.99354M7.36227 12.0671L10.9469 14.3156M23.2653 21.1847L23.241 30.2588M23.2653 21.1847L25.0622 20.1486M23.2653 21.1847L20.6311 19.7893M23.241 30.2588L25.0353 29.2227L25.0622 20.1486M25.0622 20.1486L20.6311 17.684M15.3395 7.55239L7.38924 2.99354M15.3395 7.55239L17.1362 6.51542M15.3395 7.55239V10.3551M7.38924 2.99354L9.18357 1.95703L17.1362 6.51542M17.1362 6.51542L17.1094 11.4472M18.8086 14.68L18.7818 23.7541M18.8086 14.68L10.8559 10.1212M18.8086 14.68L20.6029 13.644M18.7818 23.7541L10.8315 19.1953L10.8437 14.6582L10.8559 10.1212M18.7818 23.7541L20.5786 22.7181L20.6029 13.644M10.8559 10.1212L12.6527 9.08561L20.6029 13.644",
    stroke: "currentColor",
    strokeWidth: 0.484211,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
};

export default __webpack_public_path__ + "static/media/application_cladding.fc9455c4.svg";
export { SvgComponent as ReactComponent };